import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetUsersWithoutRoleQuery, useSetProjectMemberMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './NewProjectMemberDialog.module.css';

type NewProjectMemberDialogProps = {
    onClose: () => void,
    projectId: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewProjectMemberDialog = (props: NewProjectMemberDialogProps) => {
    const { style, visible, projectId, onClose } = props;
    const [searchUser, setSearchUser] = useState('');
    const [setProjectMember, setProjectMemberResult] = useSetProjectMemberMutation();
    const [validationError, setValidationError] = useState('');
    const users = useGetUsersWithoutRoleQuery({
        variables: { contains: searchUser }
    });

    const handleSubmit = () => {
        const selectedEmail = users.data?.UserList?.nodes?.filter(u => u?.email === searchUser)[0];
        if (!searchUser) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedEmail) {
            setValidationError('Please Select A Valid Email!');
            return;
        }
        setValidationError('');
        setProjectMember({
            variables: { id: projectId, userId: selectedEmail?.id }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            title="New Project Member"
            type="OkCancel"
            isLoading={setProjectMemberResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.NewProjectMemberDialog}
            style={style}
            data-testid="NewProjectMemberDialog">
            <FormAutoComplete
                label="Email"
                name="email"
                value={searchUser}
                onChange={setSearchUser}
                options={(users.data?.UserList?.nodes?.map(c => c?.email) || []).filter((e): e is string => !!e)}
            />
        </DialogBase>
    );
};

export default NewProjectMemberDialog;